import api from './api';

// Tax Returns API Client
export const taxReturnsAPI = {
  // Tax Returns
  createReturn: (data) => api.post('/api/tax-returns', data),
  listReturns: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.status) queryParams.append('status_filter', params.status);
    if (params.tax_year) queryParams.append('tax_year', params.tax_year);
    return api.get(`/api/tax-returns?${queryParams.toString()}`);
  },
  getReturn: (id) => api.get(`/api/tax-returns/${id}`),
  updateReturn: (id, data) => api.patch(`/api/tax-returns/${id}`, data),
  
  // Questionnaire
  saveQuestionnaire: (returnId, data) => api.post(`/api/tax-returns/${returnId}/questionnaire`, data),
  getQuestionnaire: (returnId) => api.get(`/api/tax-returns/${returnId}/questionnaire`),

  // Entity-specific questionnaire sections (B#4)
  getSections: (returnId) => api.get(`/api/tax-returns/${returnId}/sections`),
  getEntitySchemas: () => api.get('/api/tax-returns/entity-schemas'),

  // AI Review (B#4 - new feature)
  runAIReview: (returnId) => api.post(`/api/tax-returns/${returnId}/ai-review`),

  // Workpaper Generation (B#4 - new feature)
  generateWorkpaper: (returnId) => api.post(`/api/tax-returns/${returnId}/generate-workpaper`),
  getWorkpaper: (returnId) => api.get(`/api/tax-returns/${returnId}/workpaper`),
};